<template>
  <div class="modal-edit-team">
    <div class="modal-head">
      <h4>EDIT TEAM</h4>
      <a href="javascript:;" class="close" @click="$emit('close')"></a>
    </div>
    <div class="modal-body edit-team-module">
      <div class="users">
        <label>MANAGER</label>
        <ul>
          <li v-for="(user_id, index) in manager_ids" :key="index">
            <div class="u">
              <span class="avatar">{{ allStaff[user_id].initials }}</span>
              <span class="name">{{ allStaff[user_id].full_name }}</span>
            </div>
            <a href="#" @click="removeManager(index)"><span class="icon-trash"></span></a>
          </li>
        </ul>
        <Select2 v-model="adding_manager_id" class="form-control" :options="membersOptions" @change="addManager($event)" />
      </div>

      <div class="users">
        <label>TEAM MEMBERS</label>
        <ul>
          <li v-for="(user_id, index) in member_ids" :key="index">
            <div class="u">
              <span class="avatar">{{ allStaff[user_id].initials }}</span>
              <span class="name">{{ allStaff[user_id].full_name }}</span>
            </div>
            <a href="#" @click="removeMember(index)"><span class="icon-trash"></span></a>
          </li>
        </ul>
        <Select2 v-model="adding_member_id" class="form-control" :options="membersOptions" @change="addMember($event)" />
      </div>
    </div>

    <div class="modal-foot">
      <div class="btns btns-2">
        <beat-loader v-if="state == 'saving'"></beat-loader>
        <template v-else>
        <button type="button" class="btn btn-outline-black" @click="doSave">Save</button>
        <button type="button" class="btn btn-outline-gray" @click="$emit('close')">Cancel</button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ServiceJob from '@/services/job'
import Select2 from 'v-select2-component';
import BeatLoader from 'vue-spinner/src/BeatLoader'

export default {
  components: {
    Select2,
    BeatLoader
  },
  data () {
    return {
      state: '',
      adding_manager_id: 0,
      adding_member_id: 0,
      member_ids: [],
      manager_ids: [],
      membersOptions: []
    }
  },
  watch: {},
  computed: {
    ...mapGetters(['JOB']),
    ...mapState({
      allStaff: state => state.option.usersWithKey
    })
  },
  created () {},
  mounted () {
    this.init();
  },
  methods: {
    init () {
      let self = this;
      self.member_ids = self.JOB.member_ids.slice();
      self.manager_ids = self.JOB.manager_ids.slice();
      this.getMembersOptions();
    },
    getMembersOptions() {
      let self = this, options = [];
      options.push({id: 0, text: '- Select'});
      for(let i in self.allStaff){
        let staff_id = parseInt(i);
        if(self.member_ids.indexOf(staff_id) == -1 && self.manager_ids.indexOf(staff_id) == -1)
          options.push({id: self.allStaff[i].id, text: self.allStaff[i].full_name});
      }
      self.membersOptions = options;
    },
    addManager (val) {
      if(val){
        if(this.manager_ids.indexOf(val) == -1)
          this.manager_ids.push(parseInt(val));
        this.adding_manager_id = 0;
        this.getMembersOptions();
      }
    },
    removeManager (index) {
      this.manager_ids.splice(index, 1);
      this.getMembersOptions();
    },
    addMember (val) {
      if(val){
        if(this.member_ids.indexOf(val) == -1)
          this.member_ids.push(parseInt(val));
        this.adding_member_id = 0;
        this.getMembersOptions();
      }
    },
    removeMember (index) {
      this.member_ids.splice(index, 1);
      this.getMembersOptions();
    },
    doSave ( ) {
      let self = this;
      self.state = 'saving';
      ServiceJob.save(self.JOB.id, {
        member_ids: self.member_ids,
        manager_ids: self.manager_ids,
      }, job => {
        self.state = '';
        self.$notify({
          type: 'success',
          text: 'Team members updated'
        });
        self.$store.dispatch('UPDATE_JOB', job);
        self.$emit('close');
      });
    }
  }
}
</script>
